/*
 * Copyright (c) 2018 Helvia Technologies PC <contact@helvia.io>
 */

import { API_CORE_URL } from '../../../constants/env';

/**
 * Generate a Webchat script based on the given params
 *
 * @param {String} deploymentId The deployment ID.
 * @param {String} introNode The ID of the starting node.
 * @param {Boolean} isAnalyticsEnabled If analytics should be enabled for this instance.
 * @param {String} metadata Metadata to be passed to the bot preview.
 * @param {String} userName The current connected user's name.
 * @param {String} userEmail The current connected user's email.
 * @param {String} userId The current connected user's identifier.
 * @param {String} language The language which determines the flow to render.
 * @param {String} mode Determines the mode of the webchat window.
 * @returns {String} The generated script, which can be embedded in the DOM.
 */
// TODO: Replace string props (hcnButtons, extraStylesetOptions) with objects or arrays as needed
const generateWebchatScript = (
  {
    deploymentId,
    introNode,
    isAnalyticsEnabled,
    metadata,
    userName,
    userEmail,
    userId,
    language,
    mode
  }
) => {
  const script = `window.HBFWebchat.init({
      deploymentId: "${deploymentId}",
      apiUrl: "${API_CORE_URL}",
      ${mode ? `mode: "${mode}",` : ''}
      ${introNode ? `entryPoint: "${introNode}",` : ''}
    });
    window.HBF_retrieveMetadata = function() {
      return ${handleMetadata(isAnalyticsEnabled, metadata)}
    }
    window.HBF_retrieveUserInfo = function() {
      return ${handleUserInfo(userName, userEmail, language)}
    }
    window.HBF_retrieveUserId = function() {
      return ${handleUserData(userId)}
    }`;
  return script;
};

const handleUserInfo = (userName, userEmail, language) => {
  let userInfo = {
    name: userName ? `"${userName}"` : undefined,
    email: userEmail ? `"${userEmail}"` : undefined,
    language: language ? `"${language}"` : undefined
  };
  return `{
    name: ${userInfo.name},
    email: ${userInfo.email},
    language: ${userInfo.language}
  }`;
};
const handleMetadata = (isAnalyticsEnabled, metadata) => {
  let retrievedMetadata = {
    skipInternalAnalytics: !isAnalyticsEnabled,
    skipExternalAnalytics: true
  };
  try {
    metadata = JSON.parse(metadata);
    for (let entry in metadata) {
      if (
        entry !== 'skipInternalAnalytics'
        && entry !== 'skipExternalAnalytics'
      ) {
        retrievedMetadata[entry] = metadata[entry];
      }
    }
  } catch {
    metadata = undefined;
  }
  return JSON.stringify(retrievedMetadata, null, 2);
};

const handleUserData = (value) => {
  if (value) {
    return `"${value}"`;
  }
  return undefined;
};

export default generateWebchatScript;
